// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__L9Jpd","img":"styles_img__pWK1B","text":"styles_text__AgNCq","title":"styles_title__u4p3i"};